import axios from 'axios';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
import { number } from 'echarts';
const BASE_URL = NAMESPACES.management_api.user_salaries;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json'
    }
  }));

  export const getUserSalariesByLocalId = async (localId: number) => {
    return await api.get(`/GetUserSalariesByLocalId/${localId}`, {
    });
}

export const getUserSalariesByMonthYear = async (localId: number, monthYear: string, userId = number) => {
  // Validación básica de formato MMYY
  if (!/^(0[1-9]|1[0-2])\d{2}$/.test(monthYear)) {
    throw new Error("monthYear debe tener formato 'MMyy', p.ej. '0625'.");
  }
  return api.get(
    `/GetUserSalariesByMonthYear/${localId}/${monthYear}/${userId}`
  );
};

export const createUserSalary = async (SalaryData: any) => {
  return await api.post('/CreateUserSalary', SalaryData, {
  });
}

export const repeatLocalPaymentFromPreviousMonth = async (payload: { local_id: number; month_year: string; user_id: number }) => {

    return await api.post('/RepeatLocalPaymentFromPreviousMonthByUserId', payload);
};
